<div class="config-editor-container has-own-sub-chrome">
    <tam-email-digest-editor-sub-chrome *ngIf="!isPageLoading" [config]="subChromeConfig" [name]="emailDigest.name">
    </tam-email-digest-editor-sub-chrome>
    <div class="content" loading-spin [isLoading]="isPageLoading" [loadingSize]="'big'">
        <div *ngIf="!isPageLoading" class="left-box">
            <div class="preview-box">
                <div class="detail-preview-box">
                    <div class="detail-row detail-scheduler">
                        <div class="detail-sr">
                            <smart-icon name="bell-o"></smart-icon>
                            <span class="detail-text">{{emailDigest.schedulerStr}}
                                {{emailDigest.scheduler.configuration}}</span>
                        </div>
                        <div class="detail-edit" (click)="onEditDetail($event)">Edit</div>
                    </div>
                    <div class="detail-row detail-sr">
                        <smart-icon name="users-o"></smart-icon>
                        <span class="detail-text">{{recipientsStr}}</span>
                    </div>
                    <div class="detail-row detail-text">
                        Based on these settings, the next email digest email will be sent on
                        {{emailDigest.fireTime}}
                        {{emailDigest.scheduler.configuration}}
                    </div>
                </div>
                <div #sectionBox class="data-preview-box">
                    <div *ngFor="let section of emailDigest.emailSection;index as i" class="section-box"
                        [class.active]="selectedSection&&selectedSection.id===section.id"
                        (click)="onEditSection($event, section, i)">
                        <div class="section-header">
                            <div class="section-title">
                                <smart-icon name="note"></smart-icon>
                                <span>{{section.name}}</span>
                            </div>
                            <div class="meat-ball-area" (click)="onMeatball($event,section,i)">
                                <smart-icon name="meatball"></smart-icon>
                            </div>
                        </div>
                        <div class="section-body"
                            *ngIf="section.previewResult&&(previewSectionId!==section.id||(previewSectionId===section.id&&!isPreviewing))">
                            <tam-html-container [html]="section.previewResult"></tam-html-container>
                        </div>
                        <div class="section-no-body" *ngIf="!section.previewResult" loading-spin
                            [isLoading]="isPreviewing&&previewSectionId===section.id" [loadingSize]="'normal'">
                            <span>Only showing the first record for preview</span>
                        </div>
                        <div class="section-footer"
                            *ngIf="section.previewResult&&!section.showAll&&!(section.previewResult.indexOf(previewNoResultKeyword)>-1)">
                            Showing 1st record. Click
                            <span class="section-footer-button"
                                (click)="onSectionLoadAll($event, section, i)">&nbsp;here&nbsp;</span>
                            to show all
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right-box">
            <div *ngIf="!selectedSection" class="section-add-container">
                <div class="title-add">ADD SECTION</div>
                <div class="section-add" (click)="onAddSection($event, 0)">+ Note Section</div>
                <div class="section-add" (click)="onAddSection($event, 1)">+ File Section</div>
            </div>
            <div *ngIf="selectedSection" class="section-editor-container">
                <div class="menu">
                    <smart-icon name="add-cycle" class="light" (click)="onAddSectionStart($event)"></smart-icon>
                    <tam-wizard-menu [config]="wizardConfig"></tam-wizard-menu>
                </div>
                <div class="body">
                    <div class="panel">
                        <div class='panel-item' *ngIf="wizardConfig.config.active === 1">
                            <div class="config-tab-title-area">
                                <smart-icon name='config-data-source'></smart-icon>
                                <span class="h3-regular config-tab-title">DISPLAY SETTING</span>
                            </div>
                            <div class="config-tab-body-area">
                                <div class="row"
                                    *ngIf="selectedSection.displaySetting.column.length===0&&selectedSection.displaySetting.fixedColumn.length===0">
                                    <div class="error-message">Please add at least one metadata to display</div>
                                </div>
                                <div class="section-name-area tam-input-tip">
                                    <div class="section-name caption-1">Section Name</div>
                                    <input type="text"
                                        [ngClass]="{'tam-input-bad':(!selectedSection.name||selectedSection.name.length>128)}"
                                        class="tam-input" [(ngModel)]="selectedSection.name"
                                        (focusout)="validateCurrentSectionName($event)" />
                                    <div class="required-field"
                                        *ngIf="selectedSection&&selectedSection.name&&selectedSection.name.length>128">
                                        Name
                                        exceeds the maximum of 128 characters allowed.</div>
                                </div>
                                <div #anchor class="row">
                                    <label class="add-filter-btn" (click)="onAddColumn($event)">+ Add Metadata</label>
                                </div>
                                <kendo-popup [anchor]="anchor" [style.display]="showAddPopup?'':'none'">
                                    <div [style.display]="showAddPopup?'':'none'" style="width:320px;"
                                        class="add-list-container" (keydown)="onAddListKeydown($event)">
                                        <div class="add-search">
                                            <input #keywordForAddInput type="text" class="tam-input"
                                                [(ngModel)]="keywordForAdd" (keyup)="onSearchAddKeyup($event)"
                                                autocomplete="off" autocorrect="off" autocapitalize="off"
                                                spellcheck="false" (click)="emptyClick($event)" />
                                        </div>
                                        <div #addListContainer class="add-list">
                                            <div *ngFor="let item of addSearchResult;index as i">
                                                <div class="add-list-item"
                                                    [ngClass]="{'active':selectedColumnIndexForAdd===i}"
                                                    (click)="onAddColumnClick($event,item,i)">{{item.display}}</div>
                                            </div>
                                            <div class="add-list-no-item"
                                                *ngIf="keywordForAdd && (!addSearchResult || addSearchResult.length === 0)">
                                                No Results Found
                                            </div>
                                        </div>
                                    </div>
                                </kendo-popup>
                                <div class="column-box-panel">
                                    <tam-column-panel [data]="selectedSection.displaySetting.column">
                                        <ng-template #bar let-dataItem="dataItem" let-index="index">
                                            <div class="bar"
                                                [class.selected]="selectedColumn&&selectedColumn.field===dataItem.field&&selectedColumnIndex===index"
                                                (click)="onColumnClick($event,dataItem,index)">
                                                <div class="bar-left">
                                                    <smart-icon name="column-picker-drag"></smart-icon>
                                                    <span class="sub-title">{{dataItem.display}}</span>
                                                </div>
                                                <div class="bar-right">
                                                    <smart-icon name="trash"
                                                        (click)="onDeleteColumn($event, dataItem, index)"></smart-icon>
                                                </div>
                                            </div>
                                            <div class="column-detail-container"
                                                *ngIf="selectedColumn&&selectedColumn.field===dataItem.field&&selectedColumnIndex===index">
                                                <div class="title-area">
                                                    <div class="title">
                                                        <label class="title-label">Column Title <span
                                                                class="required-field">*</span></label>
                                                        <div class="title-input">
                                                            <input type="text" class="tam-input"
                                                                [(ngModel)]="selectedColumn.display"
                                                                (keyup)="onChangeColumnDisplay($event)"
                                                                placeholder="selectedColumn.field" />
                                                            <label class="title-field">Database Field:
                                                                <span
                                                                    class="font-color">{{selectedColumn.field}}</span></label>
                                                        </div>
                                                    </div>
                                                    <div class="display-setting"
                                                        *ngIf="selectedColumn&&selectedColumn.dataType==='entity'">
                                                        <div>Display</div>
                                                        <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}"
                                                            [filterable]="false" [data]="displayList"
                                                            [textField]="'value'" [valueField]="'id'"
                                                            [value]="selectedDisplay"
                                                            (valueChange)="onChangeDisplay($event)">
                                                        </kendo-dropdownlist>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </tam-column-panel>
                                    <div class="other-display-area">
                                        <div class="one-display">
                                            <label tam-checkbox [value]="showSubject"
                                                (checkedChange)="onChangeShowSubject($event)">
                                                <span class="caption-1">
                                                    {{selectedSection&&selectedSection.type==="notes"?"Show
                                                    subject":"Show
                                                    parent note's subject"}}
                                                </span>
                                            </label>
                                        </div>
                                        <div class="one-display">
                                            <label tam-checkbox [value]="showBlurb"
                                                (checkedChange)="onChangeShowBlurb($event)">
                                                <span class="caption-1">
                                                    {{selectedSection&&selectedSection.type==="notes"?"Show blurb":"Show
                                                    parent note's blurb"}}
                                                </span>
                                            </label>
                                        </div>
                                        <div class="one-display">
                                            <span class="caption-1"
                                                *ngIf="selectedSection && selectedSection.type === 'notes' ">Number
                                                of notes to display</span>
                                            <span class="caption-1"
                                                *ngIf="selectedSection && selectedSection.type === 'files'">Number
                                                of files to display</span>
                                            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}"
                                                class="display-row" [filterable]="false" [data]="rowList"
                                                [textField]="'value'" [valueField]="'id'" [value]="selectedRowNumber"
                                                (valueChange)="onChangeRow($event)">
                                            </kendo-dropdownlist>
                                        </div>
                                        <div class="one-display caption-1">Sort by</div>
                                        <div class="one-display">
                                            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}"
                                                class="display-sortby" [filterable]="false" [data]="sortByList"
                                                [textField]="'value'" [valueField]="'id'" [value]="selectedSortBy"
                                                (valueChange)="onChangeSortby($event)" [title]="selectedSortBy.value">
                                                <ng-template kendoDropDownListItemTemplate let-dataItem>
                                                    <span
                                                        style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;"
                                                        [title]="dataItem.value">
                                                        {{ dataItem.value }}</span>
                                                </ng-template>
                                            </kendo-dropdownlist>
                                        </div>
                                        <div class="one-display caption-1">Sort direction</div>
                                        <div class="one-display">
                                            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}"
                                                class="display-sortorder" [filterable]="false" [data]="sortOrderList"
                                                [textField]="'value'" [valueField]="'id'" [value]="selectedSortOrder"
                                                (valueChange)="onChangeSortorder($event)"
                                                [title]="selectedSortOrder.value">
                                                <ng-template kendoDropDownListItemTemplate let-dataItem>
                                                    <span
                                                        style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;"
                                                        [title]="dataItem.value">
                                                        {{ dataItem.value }}</span>
                                                </ng-template>
                                            </kendo-dropdownlist>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class='panel-item' *ngIf="wizardConfig.config.active === 0">
                            <tam-email-digest-filter [config]="selectedSection"
                                [minuteOffset]="emailDigest.minuteOffset">
                            </tam-email-digest-filter>
                        </div>
                    </div>
                    <div class="footer">
                        <button class="btn btn-primary" tam-button [tamType]="'primary'" [tamLoading]="isPreviewing"
                            [disabled]="isPreviewing" (click)="preview($event)">Apply
                            & Preview</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <tam-context-menu [config]="contextMenuConfig"></tam-context-menu>
</div>